import NonProfitProfileBar from '@components/NonProfitProfileBar';
import React from 'react';
import TweetEmbed from '../TweetEmbed';
import TweetPlaceholder from '../TweetPlaceholder';

function TwitterContent(props) {
  const { post } = props;
  const { nonProfit, company } = post.renderProps;
  const tweetId = post.sourcePostData.socialMediaId;

  return (
    <div className="flex flex-col items-center gap-4">
      <TweetEmbed
        tweetId={tweetId}
        options={{
          conversation: 'none',
          align: 'center',
          height: 200,
        }}
        placeholder={<TweetPlaceholder />}
      />
      {/* {nonProfit && <NonProfitProfileBar nonProfit={nonProfit} post={post} />} */}
    </div>
  );
}

export default TwitterContent;
